export default {
  EVENT: 'data-event',

  INIT: 'data-event:init',

  LOCALE: 'data-event:locale',

  LOGIN  : 'data-event:login',
  LOGOUT : 'data-event:logout',
  SIGN_UP: 'data-event:sign_up',

  ADD_TO_CART      : 'data-event:add_to_cart',
  UPDATE_CART_ITEM : 'data-event:update_cart_item',
  REMOVE_FROM_CART : 'data-event:remove_from_cart',
  VIEW_ITEM        : 'data-event:view_item',
  BEGIN_CHECKOUT   : 'data-event:begin_checkout',
  ADD_SHIPPING_INFO: 'data-event:add_shipping_info',
  ADD_PAYMENT_INFO : 'data-event:add_payment_info',
  PURCHASE         : 'data-event:purchase',

  SEARCH: 'data-event:search',

  ACCOUNT_DELETE        : 'data-event:account_delete',
  ACCOUNT_DELETE_ADDRESS: 'data-event:account_delete_address',
  ACCOUNT_EXPORT        : 'data-event:account_export',
  ACCOUNT_DISABLE       : 'data-event:account_disable',
  ACCOUNT_ENABLE        : 'data-event:account_enable',
  ACCOUNT_UPDATE        : 'data-event:account_update',
  ACCOUNT_UPDATE_ADDRESS: 'data-event:account_update_address',
  ACCOUNT_ADD_ADDRESS   : 'data-event:account_add_address',
  ACCOUNT_UPDATE_PUSH   : 'data-event:account_update_push',

  PUSH_NOTIFICATION_FOREGROUND_WILL_DISPLAY  : 'data-event:push_notification_foreground_will_display',
  PUSH_NOTIFICATION_DISMISS                  : 'data-event:push_notification_dismiss',
  PUSH_NOTIFICATION_PERMISSION_CHANGE        : 'data-event:push_notification_permission_change',
  PUSH_NOTIFICATION_PERMISSION_PROMPT_DISPLAY: 'data-event:push_notification_permission_prompt_display',
  PUSH_NOTIFICATION_CLICK                    : 'data-event:push_notification_click',
  PUSH_SLIDE_DOWN_SHOWN                      : 'data-event:push_slide_down_shown',
  PUSH_SLIDE_DOWN_ALLOW                      : 'data-event:push_slide_down_allow',
  PUSH_SLIDE_DOWN_CANCEL                     : 'data-event:push_slide_down_cancel',
  PUSH_USER_SUBSCRIPTION_CHANGE              : 'data-event:push_user_subscription_change',
  PUSH_USER_STATE_CHANGE                     : 'data-event:push_user_state_change'

}
